import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    OnInit,
    Type,
    ViewChild,
} from '@angular/core';
import { RoblexCollapsedSidepanelRef } from '../../config/collapsed-sidepanel/collapsed-sidepanel.ref';
import { RoblexCollapsedSidepanelConfig } from '../../config/collapsed-sidepanel/collapsed-sidepanel.config';
import { CollapsedSidepanelInsertionDirective } from './collapsed-sidepanel.directive';
import { Subject } from 'rxjs';

@Component({
    selector: 'roblex-collapsed-sidepanel',
    templateUrl: './collapsed-sidepanel.component.html',
    styleUrls: ['./collapsed-sidepanel.component.scss'],
})
export class CollapsedSidepanelComponent implements OnInit, AfterViewInit {
    /**
     * Component ref of modal component
     */
    componentRef: ComponentRef<any>;
    /**
     * Unique key of modal component
     */
    uniqueKey: number;
    /**
     * View child of modal component
     */
    @ViewChild(CollapsedSidepanelInsertionDirective)
    insertionPoint: CollapsedSidepanelInsertionDirective;
    /**
     * Determines whether close on
     */
    private readonly _onClose = new Subject<any>();
    /**
     * Determines whether close on
     */
    public onClose = this._onClose.asObservable();
    /**
     * Child component type of modal component
     */
    childComponentType: Type<any>;
    /**
     * Creates an instance of collapsed sidepanel component.
     * @param roblexCollapsedSidepanelConfig RoblexCollapsedSidepanelConfig
     * @param neyhazModalRef RoblexModalRef
     */
    constructor(
        public roblexCollapsedSidepanelConfig: RoblexCollapsedSidepanelConfig,
        private componentFactoryResolver: ComponentFactoryResolver,
        private cd: ChangeDetectorRef,
        private roblexCollapsedSidepanelRef: RoblexCollapsedSidepanelRef
    ) {}
    /**
     * on init
     */
    ngOnInit(): void {}
    /**
     * after view init
     */
    ngAfterViewInit() {
        this.loadChildComponent(this.childComponentType);
        this.cd.detectChanges();
    }
    /**
     * Determines whether overlay clicked on
     * @param evt any
     */
    onOutsideClicked(evt: any) {
        // console.warn(evt.target.localName);
        if (this.roblexCollapsedSidepanelConfig.backdrop && evt.target.localName === 'roblex-collapsed-sidepanel-overlay') {
            this.roblexCollapsedSidepanelRef.close();
        }
    }
    /**
     * Loads child component
     * @param componentType Type<any>
     */
    loadChildComponent(componentType: Type<any>) {
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            componentType
        );

        // console.warn(componentType);

        let viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();

        this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
}
